import BaseResource from './BaseResource';

export interface SystemConfigData {
  id: string;
  key: string;
  value: string;
}

class SystemConfigResource extends BaseResource<SystemConfigData> {
  static get storeName(): string {
    return 'SystemConfigResource';
  }

  static get endpoint(): string {
    return `/${this.scope}/system-configs`;
  }

  static async createOverride(
    key: string,
    value: string
  ): Promise<SystemConfigResource> {
    const raw: any = await this.http.post(
      `/${this.scope}/system-configs/${key}`,
      {},
      { value }
    );

    return this.upsertAndReturn(raw);
  }

  static async deleteOverride(key: string) {
    await this.http.delete(`${this.endpoint}/${key}`);
    await this.fetchMany(); // Refresh the list
  }

  static toObject(raw: any): SystemConfigResource {
    const data = raw as SystemConfigData;
    data.id = data.key;
    return new SystemConfigResource(data);
  }
}

export default SystemConfigResource;
